import {Image} from 'react-bootstrap'

export interface PictureInterface {
    picture: {
        piccm_filename: string;
        piccm_dir: string;
    };
}
export const Picture = ({picture}: PictureInterface) => {
    return (
        <Image
            src={`${picture.piccm_dir}/${picture.piccm_filename}`}
            onError={(e) => {
                e.target.src =
                    'https://medias.florajet.com/_w_/produits/no-image.jpg?w=300&h=300&org_if_sml=1'
            }}
            className={'rounded mx-auto w-75 d-block'}
            fluid
        />
    )
}
